import React, { Component } from "react";
import { Modal, Header, Table } from "semantic-ui-react";
import { hashHistory } from "react-router";
class RelatedWods extends Component {
  constructor() {
    super();
    //sets false if there are no derivatives in the root wod.
    this.state = {
      derivlist: true,
      header: ""
    };
  }
  gentable(likederivs) {
    if (likederivs && likederivs.length) {
      return (
        <Table selectable striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Work Order Number</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Contact Name</Table.HeaderCell>
              <Table.HeaderCell>Budget</Table.HeaderCell>
              <Table.HeaderCell>Remaining</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.findsimilarwods(likederivs)}</Table.Body>
        </Table>
      );
    }
  }
  findsimilarwods(likederivs) {
    return likederivs.map(wod => {
      return (
        <Table.Row
          active={this.props.wod.workOrderNbr === wod.workOrderNbr}
          onClick={() => {
            hashHistory.push("/work-orders/" + wod.workOrderNbr);
            window.location.reload();
          }}
        >
          <Table.Cell>{wod.workOrderNbr}</Table.Cell>
          <Table.Cell>{wod.description}</Table.Cell>
          <Table.Cell>{wod.contactName}</Table.Cell>
          <Table.Cell>${wod.budget}</Table.Cell>
          <Table.Cell>${wod.remaining}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    var likederivs;
    var newheader;
    if (this.props.wod && this.props.wods) {
      let custName = this.props.findcustomer(this.props.wod.custnumber);
      let rootwonton = this.props.wod.workOrderNbr.slice(0, 7);
      likederivs = this.props.wods.filter(
        wod => wod.workOrderNbr.slice(0, 7) === rootwonton
      );
      if (likederivs.length > 1) {
        newheader = "Below is a list of derivatives for " + rootwonton;
        if (this.state.header === "") {
          this.setState({ header: newheader });
        }
        if (!this.props.similarwods.length) {
          console.log("likederivs", likederivs);
          this.props.updateWodState(likederivs);
        }
      }
    } else {
      newheader =
        "There are no known derivatives for " + this.props.wod.workOrderNbr;
    }
    return (
      <div className="RelatedWods">
        <Modal
          open={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          basic={!this.state.derivlist}
          closeOnEscape={true}
          size="large"
          closeOnRootNodeClick={true}
        >
          <Header textAlign="center">{newheader}</Header>
          <Modal.Content>{this.gentable(likederivs)}</Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default RelatedWods;



// WEBPACK FOOTER //
// ./src/components/wod/relatedwods.jsx